import React, { ChangeEvent, useCallback, useState } from "react";
import { Box } from '@pancakeswap/uikit';
import {
  BunnySlider,
  BarBackground,
  BarProgress,
  StyledInput,
  SliderLabel,
  SliderLabelContainer,
  TransparentInput,
  PercentageSign,
  InputWrapper
} from "./styles";
import SliderProps from "./types";

const Slider: React.FC<React.PropsWithChildren<SliderProps>> = ({
  name,
  min,
  max,
  value,
  onValueChanged,
  valueLabel,
  step = "any",
  disabled = false,
  ...props
}) => {
  // State to hold and update the direct input value
  const [inputValue, setInputValue] = useState(value.toString());

  const handleChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      const newValue = parseFloat(target.value);
      onValueChanged(newValue);
      setInputValue(newValue.toString()); // Update input value state as well
    },
    [onValueChanged]
  );

  const handleInputChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      const newValue = target.value;
      const numericValue = parseFloat(newValue);
      if (numericValue > 100.0) {
        return;
      }

      if (!Number.isNaN(numericValue) && numericValue >= min && numericValue <= max) {
        onValueChanged(numericValue);
      }
      setInputValue(newValue); // Allow the user to see what they type
    },
    [onValueChanged, min, max]
  );

  const progressPercentage = ((value - min) / (max - min)) * 100; // Adjusted to consider min value
  const isMax = value === max;
  const labelProgress = `${progressPercentage}%`;

  return (
    <Box position="relative" height="48px" {...props}>
      <BunnySlider>
        <BarBackground disabled={disabled} />
        <BarProgress style={{ width: `${progressPercentage}%` }} disabled={disabled} />
        <StyledInput
          name={name}
          type="range"
          min={min}
          max={max}
          value={value}
          step={step}
          onChange={handleChange}
          isMax={isMax}
          disabled={disabled}
        />
      </BunnySlider>
      <SliderLabelContainer>
        <InputWrapper>
          <TransparentInput
            type="number" // Consider changing to "number" if you want numeric input only
            value={inputValue}
            defaultValue='0'
            onChange={handleInputChange}
            disabled={disabled}
          />
          <PercentageSign>%</PercentageSign>
        </InputWrapper>
      </SliderLabelContainer>
    </Box>
  );
};

export default Slider;
